var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEye = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_889_15305)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 13,
    rx: 7,
    width: 16,
    x: 3,
    y: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m9.87,8.47c0.3,-0.31 0.7,-0.47 1.13,-0.47c0.43,0 0.83,0.16 1.13,0.47c0.31,0.3 0.47,0.7 0.47,1.13c0,0.43 -0.16,0.83 -0.47,1.13c-0.3,0.31 -0.7,0.47 -1.13,0.47c-0.43,0 -0.83,-0.16 -1.13,-0.47c-0.31,-0.3 -0.47,-0.7 -0.47,-1.13c0,-0.43 0.16,-0.83 0.47,-1.13zm1.13,0.4c-0.19,0 -0.38,0.08 -0.52,0.21c-0.13,0.14 -0.21,0.33 -0.21,0.52c0,0.19 0.08,0.38 0.21,0.52c0.14,0.13 0.33,0.21 0.52,0.21c0.19,0 0.38,-0.08 0.52,-0.21c0.13,-0.14 0.21,-0.33 0.21,-0.52c0,-0.19 -0.08,-0.38 -0.21,-0.52c-0.14,-0.13 -0.33,-0.21 -0.52,-0.21z",
    fill: "black",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m6.26,9.6c1.32,2.09 2.9,3.06 4.74,3.06c1.84,0 3.42,-0.97 4.74,-3.06c-1.32,-2.09 -2.9,-3.06 -4.74,-3.06c-1.84,0 -3.42,0.97 -4.74,3.06zm-0.89,-0.23c1.46,-2.42 3.33,-3.71 5.63,-3.71c2.3,0 4.17,1.29 5.63,3.71c0.08,0.14 0.08,0.32 0,0.46c-1.46,2.42 -3.33,3.71 -5.63,3.71c-2.3,0 -4.17,-1.29 -5.63,-3.71c-0.08,-0.14 -0.08,-0.32 0,-0.46z",
    fill: "black",
    fillRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_889_15305",
    x: 0,
    y: 0,
    width: 22,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_889_15305"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_889_15305",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye.dd1c678dfd98e9ba0b1204175221defb.svg";